import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {
	getEstablishmentList as getEstablishmentListApi,
	getEstablishmenQuery as getEstablishmenQueryApi,
	getEstablishment as getEstablishmentApi,
	addNewEstablishment as addNewEstablishmentApi,
	updateEstablishment as updateEstablishmentApi,
	deleteEstablishment as deleteEstablishmentApi,
	getProductiveCycleActive as getProductiveCycleActiveApi,
	getEstablishmentListForMap as getEstablishmentListForMapApi
} from '../../helpers/establishment/backend_helper';

export const getEstablishmentList = createAsyncThunk('establishments/getEstablishmentList', async (params) => {
	try {
		const response = getEstablishmentListApi(params);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getEstablishmentListForMap = createAsyncThunk('establishments/getEstablishmentListForMap', async (params) => {
	try {
		const response = getEstablishmentListForMapApi(params);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getEstablishmentQuery = createAsyncThunk('establishments/getEstablishmentQuery', async (params) => {
	try {
		const response = getEstablishmenQueryApi(params);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getEstablishment = createAsyncThunk('establishments/getEstablishment', async establishment_id => {
	try {
		const response = getEstablishmentApi(establishment_id);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const addNewEstablishment = createAsyncThunk('establishments/addNewEstablishment', async establishment => {
	try {
		const response = addNewEstablishmentApi(establishment);
		toast.success('Establecimiento agregado exitosamente.', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al agregar establishment.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const updateEstablishment = createAsyncThunk('establishments/updateEstablishment', async (establishment) => {
		try {
			const response = updateEstablishmentApi(establishment);
			toast.success('Establecimiento actualizado exitosamente', { autoClose: 3000 });
			return response;
		} catch (error) {
			toast.error('Error al actualizar establishment.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const deleteEstablishment = createAsyncThunk('establishments/deleteEstablishment', async establishment => {
	try {
		const response = await deleteEstablishmentApi(establishment);
		toast.success('Establecimiento eliminado exitosamente.', { autoClose: 3000 });
		return { establishment, ...response };
	} catch (error) {
		toast.error('Error al eliminar establishment.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const getProductiveCycleActive = createAsyncThunk('establishments/getProductiveCycleActive', async (establishment) => {
	try {
		const response = getProductiveCycleActiveApi(establishment);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});
